import { Link } from "react-router-dom";
import { Ladybug } from "@/components/site/Ladybug";

export const Footer = () => (
  <footer className="relative bg-[#577731] text-[#faf7f2] mt-32">
    <Ladybug spot="tr" size={22} rotate={-120} className="!top-6 !right-10" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="relative bg-[#faf7f2] rounded-3xl p-4 w-44">
          <img src="/img/logo.jpg" alt="The Healers University logo" className="w-full mix-blend-multiply" />
        </div>
        <p className="font-serif-h text-2xl mt-8 italic max-w-sm">You were never meant to heal alone. <Ladybug size={20} rotate={45} /></p>
        <button onClick={() => window.dispatchEvent(new Event("open-tea"))} data-testid="footer-tea-btn" className="mt-6 text-sm underline underline-offset-4 hover:text-[#b1cc90] transition-colors">Subscribe to Get the Tea Weekly</button>
      </div>
      <div className="md:col-span-3 flex flex-col gap-3 text-sm">
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#b1cc90] mb-2">The Medicine</span>
        <Link to="/clinic" className="hover:text-[#b1cc90] transition-colors">The Healers Clinic</Link>
        <Link to="/clinic#womb" className="hover:text-[#b1cc90] transition-colors">The Healing Womb</Link>
        <Link to="/university" className="hover:text-[#b1cc90] transition-colors">The Healers University</Link>
        <Link to="/ambassadors" className="hover:text-[#b1cc90] transition-colors">The Healing Ambassadors</Link>
        <Link to="/blog" className="hover:text-[#b1cc90] transition-colors">Blog</Link>
      </div>
      <div className="md:col-span-4 flex flex-col gap-3 text-sm">
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#b1cc90] mb-2">Reach the Circle</span>
        <a href="mailto:thehealers@thuniversity.education" data-testid="footer-email" className="hover:text-[#b1cc90] transition-colors">thehealers@thuniversity.education</a>
        <a href="https://thehealersmarket.shop" target="_blank" rel="noreferrer" className="hover:text-[#b1cc90] transition-colors">TheHealersMarket.shop</a>
        <Link to="/apply" data-testid="footer-apply-link" className="btn bg-[#faf7f2] text-[#577731] mt-4 w-fit hover:bg-[#b1cc90]">Begin Your Application</Link>
      </div>
    </div>
    <div className="border-t border-white/15 text-center text-xs py-6 text-white/70">
      © {new Date().getFullYear()} The Healers University. With gratitude to those who came before us.
    </div>
  </footer>
);
